import React from 'react';
import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/layout/select-window/config';
import FormBtn from '@framework/workbench/drawer/components/form-btn';
import i18n from '@i18next/i18n';
import { SelectWindowShowAction } from '@src/js/constant';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@Feature()
export class SelectWindowFeature extends BaseDrawerFeature {
    id = FORM_CONFIGS[0].name;
    config = FORM_CONFIGS[0];

    public renderReset() {
        return <FormBtn text={i18n.t('全部图层')} onClick={this.handleSelectWindow}/>;
    }

    private handleSelectWindow = (): void => {
        (this.getAppService() as IPcEditorAppServices)
            .editableServiceLayer?.rightSideBarManager?.setSelectWindowShowAction(SelectWindowShowAction.FROM_FORMAT);
        this.drawerCallback();
    };
}
